import React, { Component } from 'react';
import PropTypes from 'prop-types';

const filterNames = {
  isPreviouslyPurchasedOnly: 'Previously Purchased Items',
  categories: 'Category',
  colors: 'Color',
  conditions: 'Condition',
  lVolumes: 'Volume (L)',
  mlVolumes: 'Volume (mL)',
  packAmounts: 'Pack Amount',
  pageYields: 'Page Yield',
  photosYields: 'Photo Yield',
  sizes: 'Size',
  staplesYields: 'Staple Yield',
  manufacturers: 'Brand',
  subcategories: 'Subcategory',
};

const filterGroups = {
  ink: ['colors', 'conditions', 'manufacturers', 'pageYields', 'lVolumes', 'mlVolumes'],
  drums: ['colors', 'conditions', 'manufacturers'],
  filaments: ['colors', 'conditions', 'manufacturers'],
  micr: ['conditions', 'manufacturers', 'pageYields'],
  fusers: ['conditions', 'manufacturers'],
  maintenance: ['conditions', 'manufacturers'],
  parts: ['subcategories'],
  staples: ['staplesYields'],
};

const filterGroupNames = {
  ink: 'Ink & Toner',
  drums: 'Drums & Photoconductors',
  filaments: 'Filaments',
  micr: 'MICR',
  fusers: 'Fusers',
  maintenance: 'Maintenance Kits',
  parts: 'Parts',
  staples: 'Staples',
};

const collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});

class BrowseFilter extends Component {
  constructor(props) {
    super(props);

    // This binding is necessary to make `this` work in the callback
    this.toggleFilter = this.toggleFilter.bind(this);

    this.state = {
      isFilterToggled: false,
      expandedSections: ['ink', 'filaments']
    };
  }

  isContainerChecked(filters, filterGroups, filterValues) {
    let isAllSelected = true;

    filterGroups.map(id => {
      if (!filters.hasOwnProperty(id) || !filterValues.hasOwnProperty(id)) {
        return;
      }

      if (Object.keys(filters[id]).length != filterValues[id].length) {
        isAllSelected = false;
        return;
      }
    });

    return isAllSelected;
  }

  handleContainerCheck(filters, filterGroups, filterValues, isOn, categoryId) {
    if (this.props.isReadOnly) return false;

    if (isOn) {
      this.handleContainerToggle(categoryId, true);
    }

    filterGroups.map(id => {
      if (!filters.hasOwnProperty(id) || !filterValues.hasOwnProperty(id)) {
        return;
      }

      this.props.onChange(isOn, categoryId, id, Object.keys(filters[id]).join('|'));
    });
  }

  handleContainerToggle(categoryId, isForcedOn = false) {
    if (this.props.isReadOnly) return false;
    
    let expandedSections = this.state.expandedSections;

    const isOn = isForcedOn || !expandedSections.includes(categoryId);

    if (isOn) {
      expandedSections.push(categoryId);
    } else {
      expandedSections = expandedSections.filter(value => value != categoryId);
    }

    this.setState({ expandedSections });
  }

  toggleFilter() {
    this.setState({
      isFilterToggled: !this.state.isFilterToggled
    });
  }

  render() {
    const groups = this.props.filters.groups,
      isPreviouslyPurchased = !!this.props.filters.isPreviouslyPurchased,
      filterValues = this.props.filterValues;

    return (
      <div className="product-filters">
        <button className="button tiny -gray hide-for-medium" onClick={this.toggleFilter}>
          {
            this.state.isFilterToggled
              ? <span>&times; Hide Filters</span>
              : <span><i className="icon-bars"/> Show Filters</span>
          }
        </button>

        <div className={`product-filters__inner ${this.state.isFilterToggled ? '' : 'show-for-medium'}`}>
          <h2>Refine by</h2>

          {
            isPreviouslyPurchased &&
            (
              <div className="product-filters__group">
                <h3>
                  <input type="checkbox" value="1"
                         checked={filterValues._ && filterValues._.isPreviouslyPurchasedOnly && filterValues._.isPreviouslyPurchasedOnly.includes('1')}
                         onChange={e => this.props.onChange(e.target.checked, '_', 'isPreviouslyPurchasedOnly', '1')} readOnly={this.props.isReadOnly} />
                  {' '}
                  Previously Purchased Items
                </h3>
              </div>
            )
          }

          {
            Object.keys(filterGroups).map(filterGroupId =>
              Object.keys(groups).map(categoryId => {

                if (filterGroupId != categoryId) {
                  return;
                }

                const filters = groups[categoryId];
                const hasChildOptions = filterGroups[categoryId].filter(val => Object.keys(filters).includes(val)).length > 0;

                return (
                  hasChildOptions
                    ? <div key={categoryId} className="product-filters__container">
                        <h3 className="product-filters__container__title">
                          <input type="checkbox" value={categoryId} checked={hasChildOptions ? this.isContainerChecked(filters, filterGroups[categoryId], filterValues[categoryId]) : filterValues[categoryId].hasOwnProperty('_') && filterValues[categoryId]._.length > 0}
                                onChange={e => this.handleContainerCheck(filters, filterGroups[categoryId], filterValues[categoryId], e.target.checked, categoryId)} readOnly={this.props.isReadOnly} />
                          {' '}
                          <a className="product-filters__container__toggle" onClick={() => this.handleContainerToggle(categoryId)}>
                            <span>{`${filterGroupNames[filterGroupId]}`}</span>
                            {' '}
                            <i className={`icon-caret-${!this.state.expandedSections.includes(categoryId) ? 'down' : 'up'}`}/>
                          </a>
                        </h3>
                        <div className={`product-filters__container__group ${this.state.expandedSections.includes(categoryId) ? '-expanded' : ''}`}>

                          {
                            filterGroups[categoryId].map(filterId =>
                              Object.keys(filters).includes(filterId) &&
                              <div key={filterId} className="product-filters__group">

                                {
                                  filterId != 'subcategories' &&
                                  <h4>{filterNames[filterId]}</h4>
                                }

                                <ul className="product-filters__group__values">
                                  {
                                    Object.entries(filters[filterId]).sort(([,a], [,b]) => collator.compare(a, b)).map(([value]) =>
                                      <li key={value}>
                                        <label>
                                          <input type="checkbox" value={value}
                                                checked={filterValues[categoryId] && filterValues[categoryId][filterId] && filterValues[categoryId][filterId].includes(value)}
                                                onChange={e => this.props.onChange(e.target.checked, categoryId, filterId, value)} />
                                          <span>{filters[filterId][value]}</span>
                                        </label>
                                      </li>
                                    )
                                  }
                                </ul>
                              </div>
                            )
                          }

                        </div>
                      </div>

                    : <div key={categoryId} className="product-filters__container">
                        <h3 className="product-filters__container__title">
                          <label className="product-filters__container__title__label">
                            <input type="checkbox" value="_"
                                  checked={filterValues[categoryId] && filterValues[categoryId]['_'] && filterValues[categoryId]['_'].includes('_')}
                                  onChange={e => this.props.onChange(e.target.checked, categoryId, '_', '_')} />
                            {' '}
                            <span>{`${filterGroupNames[filterGroupId]}`}</span>
                          </label>
                        </h3>
                      </div>

                );
              })
            )
          }
        </div>
      </div>
    );
  }
}

BrowseFilter.propTypes = {
  filters: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  filterValues: PropTypes.object.isRequired,
  isReadOnly: PropTypes.bool,
};

export default BrowseFilter;
